import React, { useState } from 'react';

// Импорт микросервисов:
import LiveServicePage from './pages/LiveServicePage';
import ListenersServicePage from './pages/ListenersServicePage';
import GeoServicePage from './pages/GeoServicePage';
import LoyaltyServicePage from './pages/LoyaltyServicePage';
import RetentionServicePage from './pages/RetentionServicePage';
import PeakServicePage from './pages/PeakServicePage';
import AhaServicePage from './pages/AhaServicePage';
import NewListenersServicePage from './pages/NewListenersServicePage';
import TslServicePage from './pages/TslServicePage';
import TlhServicePage from './pages/TlhServicePage';
import Top40ServicePage from './pages/Top40ServicePage';
import AdsServicePage from './pages/AdsServicePage';
import AdrServicePage from './pages/AdrServicePage';

const tabs = [
  { key: 'current', label: 'Зараз слухають', component: LiveServicePage },
  { key: 'listeners', label: 'Слухачі', component: ListenersServicePage },
  { key: 'geo', label: 'Географія', component: GeoServicePage },
  { key: 'loyalty', label: 'Лояльність', component: LoyaltyServicePage },
  { key: 'retention', label: 'Утримання', component: RetentionServicePage },
  { key: 'peak', label: 'Пік', component: PeakServicePage },
  { key: 'aha', label: 'AHA', component: AhaServicePage },
  { key: 'new', label: 'Нові слухачі', component: NewListenersServicePage },
  { key: 'adr', label: 'ADR', component: AdrServicePage },
  { key: 'ads', label: 'Реклама', component: AdsServicePage },
  { key: 'tsl', label: 'TSL', component: TslServicePage },
  { key: 'tlh', label: 'TLH', component: TlhServicePage },
  { key: 'top40', label: 'Top-40', component: Top40ServicePage },
];

// ...импорты

const Statistics = () => {
  const [activeTab, setActiveTab] = useState('current');
  const ActiveComponent = tabs.find(tab => tab.key === activeTab).component;

  return (
    <div
      style={{
        width: 900,
        margin: '40px auto',
        borderRadius: 12,
        background: '#3688c8',
        padding: 28,
        minHeight: 550,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          marginBottom: -2,
          maxWidth: 860,
        }}
      >
        {tabs.map(tab => (
          <div
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '10px 30px',
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              background: activeTab === tab.key ? '#fff' : '#398fd2',
              color: activeTab === tab.key ? '#222' : '#d1e9fa',
              fontWeight: activeTab === tab.key ? 700 : 500,
              marginBottom: 0,
              boxShadow: activeTab === tab.key ? '0 -2px 8px #c8e0fa44' : 'none',
              cursor: 'pointer',
              border: activeTab === tab.key ? '2px solid #3688c8' : '2px solid #398fd2',
              borderBottom: activeTab === tab.key ? 'none' : '2px solid #398fd2',
              position: 'relative',
              top: activeTab === tab.key ? 4 : 12,
              zIndex: activeTab === tab.key ? 2 : 1,
              transition: 'all 0.15s',
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          minHeight: 400,
          maxWidth: 780,
          width: '100%',
          padding: '32px 24px',
          boxShadow: '0 4px 16px #0001',
          color: '#222',
          fontSize: 18,
          zIndex: 1,
          position: 'relative',
          marginBottom: 24,
          marginTop: 18,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          boxSizing: 'border-box',
        }}
      >
        <ActiveComponent />
      </div>
    </div>
  );
};

export default Statistics;
